import React, { useEffect } from "react";

import { homeAppCheckVersion } from "../../service/api";

interface IProps {
  type: "android" | "ios";
}

const DownloadBtn: React.FC<IProps> = (props) => {
  const { type } = props;
  let downloadUrl: string = "";
  const icon =
    type === "android"
      ? require("../../assets/images/home/android.webp")
      : require("../../assets/images/home/iphone.webp");
  const default_download =
    type === "android"
      ? "https://play.google.com/store/apps/details?id=com.aipeak.picxs"
      : "https://apps.apple.com/us/app/ipicx/id6476877278";

  useEffect(() => {
    homeAppCheckVersion({
      appKey: type === "android" ? "com.aipeak.picx" : "AI_BEAUTY_A_I",
    }).then((res) => {
      if (res.code === 0) {
        downloadUrl = res.data.downloadUrl ? res.data.downloadUrl : default_download;
      } else {
        downloadUrl = default_download;
      }
    });
  }, []);
  const downloadHandler = () => {
    window.location.href = default_download;
  };
  return (
    <div
      onClick={downloadHandler}
      className="bg-black text-white flex items-center px-10 py-8 rounded-50"
    >
      <img className="mr-2" width="15" src={icon} />
      {type === "android" ? "Android " : "iOS "}Download
    </div>
  );
};

export default DownloadBtn;
